const style = {
  container: {
    display: "flex",
    justifyContent: "center",
  },
  modalWrapper: {
    width: "100vw",
    height: "100vh",
    position: "absolute" as const,
    top: 0,
    left: 0,
    zIndex: 4,
  },
  backdropFilter: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
  },
  modal: {
    maxWidth: 632,
    width: "100%",
    backgroundColor: "#fff",
    zIndex: 1,
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column" as const,
    padding: "50px 58px 70px",
    borderRadius: 8,
  },
  closeButton: {
    position: "absolute" as const,
    top: 30,
    right: 30,
    opacity: 0.5,
    "&:hover": {
      opacity: 1,
    },
    cursor: "pointer",
  },
  header: {
    fontFamily: "Proxima Nova Alt",
    fontSize: 24,
    fontWeight: 700,
    color: "#011533",
    alignSelf: "center",
    marginBottom: 10,
    marginTop: 22,
  },
  info: {
    fontSize: "16px",
    lineHeight: "22px",
    marginBottom: 8,
    color: "#00112B",
  },
  deepPink: {
    color: "#DE2F4C",
  },
  pdfInfo: {
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: 700,
    color: "#00112B",
    display: "flex",
    alignItems: "center",
  },
  horizontalSpace: {
    width: 18,
  },
  buttons: {
    width: 407,
    display: "flex",
    justifyContent: "space-between",
  },
  button: {
    width: 152,
    height: 48,
    textTransform: "none" as const,
    borderColor: "#273754",
    borderRadius: 16,
    padding: "14px 20px",
    fontSize: 16,
    color: "#00112B",
    fontWeight: "bold" as const,
    "&:not(:last-child)": { marginRight: 112 },
    "&:last-child": {
      backgroundColor: "#EE4360",
      border: "none",
      color: "#FFFFFF",
    },
    "&:disabled": {
      backgroundColor: "#C2C8D1",
    },
  },
  dragAndDropWrapper: {
    marginTop: "-30px",
  },
};

export default style;
